import { createContext } from "react";
export const WorkflowDockContext = createContext(null);
